import React from "react";
import PropTypes from "prop-types";
import SelectionsLoadingSkeleton from "../../../../components/SelectionsLoadingSkeleton";
import SelectionRow from "../../../../components/SelectionRow";
import styles from "./ShuffleSelections.module.scss";

const ShuffleSelections = ({ selections, isLoading }) => {
  if (isLoading)
    return (
      <div className={styles["shuffleSelections--loading"]}>
        <SelectionsLoadingSkeleton selections={selections} shuffle />
      </div>
    );

  if (!selections.length) return null;

  return (
    <div className={styles.shuffleSelections} data-testid="bet-shuffle">
      {selections.map((selection) => (
        <SelectionRow
          key={`selection-${selection.mappedEventId}-${selection.selection.id}-${selection.selection.marketId}`}
          {...selection}
          location="Shuffle"
        />
      ))}
    </div>
  );
};

ShuffleSelections.propTypes = {
  selections: PropTypes.arrayOf(
    PropTypes.shape({
      probability: PropTypes.number,
      mappedEventId: PropTypes.string,
      selection: PropTypes.shape({
        commonID: PropTypes.number,
        id: PropTypes.string,
        marketId: PropTypes.string,
        name: PropTypes.string,
        odds: PropTypes.string,
        oddsDecimal: PropTypes.number,
        type: PropTypes.string,
      }),
      homeTeamName: PropTypes.string,
      awayTeamName: PropTypes.string,
      date: PropTypes.string,
      competitionName: PropTypes.string,
      stats: PropTypes.arrayOf(
        PropTypes.shape({
          numberOfMatches: PropTypes.number,
          numberOfWins: PropTypes.number,
          probability: PropTypes.number,
          type: PropTypes.string,
        })
      ),
      type: PropTypes.string,
    })
  ),
  isLoading: PropTypes.bool,
};

export default ShuffleSelections;
